import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import * as Yup from 'yup';
import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Switch } from '@mui/material';
import { GetAccessToken } from "../components/Dashboard/Utilities";
import moment from 'moment';
import { set } from 'date-fns';

export function handleSwitchChange(cellValues, rowId, accessToken, showSuccess, showError) {
    var data = { id: rowId, accessToken: accessToken };
    //console.log('data: ' + JSON.stringify(data));
    saveApp(data, 'own', showError, showSuccess, null, null);

    //console.log(cellValues); 
    cellValues.row.isSchoolRecord = !cellValues.row.isSchoolRecord;
}
export default function useGridColumnSetup(handleClickOpen, handleDeleteOpen, showSuccess, showError, isSuperAdmin) {

    var accessToken;
    GetAccessToken(null, accessToken).then(result => {
        // console.log('result: ' + result);
        accessToken = result;

    }).catch(err => {
        alert(err);
    });
    const columns = [

        {
            field: "Actions", minWidth: 90, sortable: false, disableExport: true,

            renderCell: (cellValues) => {
                return (
                    <div>
                        <Button
                            sx={{ minWidth: 34, padding: 0 }}
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {(cellValues.row.isSchoolRecord || isSuperAdmin) && (
                            <Button
                                sx={{ minWidth: 34, padding: 0 }}
                                variant="outlined"
                                color="primary"
                                onClick={(event) => {
                                    handleDeleteOpen(event, cellValues);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        )}
                    </div>
                );
            }
        },
        {
            field: "isSchoolRecord", headerName: 'Institution Record', minWidth: 170, type: 'boolean',
            renderCell: (cellValues) => {
                if (cellValues.row.isSchoolRecord) {
                    if (cellValues.row.requestStatus === 1) {
                        return ('Y (In Progress)')
                    }
                    return ('Y')
                }
                else {
                    return (<Switch
                        //disabled={!currentUser.isSuperAdmin}
                        checked={cellValues.row.isSchoolRecord}
                        onClick={(event) => {
                            handleSwitchChange(cellValues, cellValues.row.id, accessToken, showSuccess, showError);
                        }}

                        name="schoolRecord"

                    />)
                }
            }
        },
        { field: 'vendorConfirmed', headerName: 'Vendor Confirmed', minWidth: 130, maxWidth: 200, type: 'boolean',flex: 1,
             renderCell: (cellValues) => {
               
                if (cellValues.row.vendorConfirmed === true) {
                    return ('Yes');
                } else {
                    return ('');
                }
               
            }
         },
        { field: 'name', headerName: 'Application Name', minWidth: 100, maxWidth: 300, flex: 1 },
        { field: 'vendorName', headerName: 'Vendor', minWidth: 130, maxWidth: 200, flex: 1 },
        {
            field: 'url', headerName: 'URL', minWidth: 150, flex: 1,
            renderCell: (cellValues) => {
                var fullUrl;
                if (cellValues.row.url !== null && cellValues.row.url.startsWith('www')) {
                    fullUrl = 'http://' + cellValues.row.url;
                } else {
                    fullUrl = cellValues.row.url;
                }
                return (<a target="_blank" rel="noreferrer" href={fullUrl}>{cellValues.row.url}</a>)
            }
        },
        { field: 'description', headerName: 'Description', minWidth: 170, flex: 1, hide: true },
        {
            field: 'expired', headerName: 'Expired', minWidth: 27, flex: 1, hide: true, type: 'boolean'
        },
        { field: "approvalTotals", headerName: 'Institutions Approved', minWidth: 150, sortable: false, hide: false, },
        { field: "cloudHosted", headerName: 'Cloud Hosted', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "cloudProvider", headerName: 'Cloud Provider', minWidth: 150, sortable: false, hide: true, },
        { field: "cloudProviderOther", headerName: 'Cloud Provider', minWidth: 150, sortable: false, hide: true, },
        { field: "startDate", headerName: 'Start Date', minWidth: 150, sortable: false, hide: true, },
        { field: "endDate", headerName: 'End Date', minWidth: 150, sortable: false, hide: true, },
        { field: "itOwnerName", headerName: 'IT Owner', minWidth: 150, sortable: false, hide: true, },
        {
            field: "collectionModesSelected", headerName: 'Collection Mode', minWidth: 150, sortable: false, hide: true,
            renderCell: (cellValues) => {
                //check if null

                if (cellValues.row.collectionModesSelected === null || cellValues.row.collectionModesSelected.length === 0) {
                    return ('');
                }
                return (cellValues.row.collectionModesSelected.join('; '));
            },
            valueGetter: (params) => {
                if (params.row.collectionModesSelected === null || params.row.collectionModesSelected.length === 0) {
                    return ('');
                }
                return (params.row.collectionModesSelected.join(', '));
            }
        },
        { field: "gradesSelectedNames", headerName: 'Applicable Grades', minWidth: 150, sortable: false, hide: true, },
        { field: "areaOfUseSelected", headerName: 'Department of Responsibility', minWidth: 150, sortable: false, hide: true, },
        { field: "generalApplicationNotes", headerName: 'General Application Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "studentInfoSelectedNames", headerName: 'Student Information', minWidth: 150, sortable: false, hide: true, },
        { field: "employeeInfoSelectedNames", headerName: 'Employee Information', minWidth: 150, sortable: false, hide: true, },
        { field: "parentInfoSelectedNames", headerName: 'Parent/Guardian Information', minWidth: 150, sortable: false, hide: true, },
        { field: "alumniInfoSelectedNames", headerName: 'Alumni Information', minWidth: 150, sortable: false, hide: true, },
        { field: "volunteerInfoSelected", headerName: 'Volunteer Information', minWidth: 150, sortable: false, hide: true, },
        { field: "other", headerName: 'Other', minWidth: 150, sortable: false, hide: true, },
        { field: "dataCollectionNotes", headerName: 'Data Collection Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyNotification", headerName: 'Privacy Notification', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyTraining", headerName: 'Privacy Training', minWidth: 150, sortable: false, hide: true, },
        { field: "subcontractors", headerName: 'Subcontractors', minWidth: 150, sortable: false, hide: true, },
        { field: "subcontractorDataProtection", headerName: 'Subcontractors Data Protection', minWidth: 150, sortable: false, hide: true, },
        { field: "auditFrequencySelectedName", headerName: 'Audit Frequency', minWidth: 150, sortable: false, hide: true, },
        { field: "lastAuditDate", headerName: 'Last Audit Date', minWidth: 150, sortable: false, hide: true, },
        { field: "securityBreachPlan", headerName: 'Security Breach Plan', minWidth: 150, sortable: false, hide: true, },
        { field: "securityBreachInt", headerName: 'Security Breach', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "securityBreachDescription", headerName: 'Security Breach Description', minWidth: 150, sortable: false, hide: true, },
        { field: "privacyPracticeReview", headerName: 'Privacy Practice Review', minWidth: 150, sortable: false, hide: true, },
        { field: "vendorSaleAssurance", headerName: 'Vendor Sales Assurance', minWidth: 150, sortable: false, hide: true, },
        { field: "dataProtectionNotes", headerName: 'Data Protection Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "dataBackup", headerName: 'Data Backup', minWidth: 150, sortable: false, hide: true, },
        { field: "lossProtection", headerName: 'Data Loss Protection', minWidth: 150, sortable: false, hide: true, },
        { field: "dataSinglePurpose", headerName: 'Data Single Purpose', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "dataRetentionPolicy", headerName: 'Data Retention Policy', minWidth: 150, sortable: false, hide: true, },
        { field: "dataRetentionLength", headerName: 'Data Retention Length', minWidth: 150, sortable: false, hide: true, },
        { field: "dataAfterDiscontinuing", headerName: 'Data Discontinuance', minWidth: 150, sortable: false, hide: true, },
        { field: "dataHandlingNotes", headerName: 'Data Handling Notes', minWidth: 150, sortable: false, hide: true, },
        { field: "gDPRCompliant", headerName: 'GDPR Compliant', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "internetPIPublished", headerName: 'Personal Info Published', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "complianceNotes", headerName: 'ComplianceNotes', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "dataBreachCompliant", headerName: 'Data Breach Compliant', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "approved", headerName: 'Approved', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "notApproved", headerName: 'Not Approved', minWidth: 150, sortable: false, type: 'boolean', hide: true, },
        { field: "notApprovedReason", headerName: 'Not Approved Reason', minWidth: 150, sortable: false, hide: true, },
        {
            field: "approvalDate", headerName: 'Approval Date', minWidth: 150, sortable: false, hide: false,
            valueFormatter: (params) => params.value ? moment(params?.value).format("DD/MM/YYYY") : ''
        },
        { field: "approverName", headerName: 'Approver Name', minWidth: 150, sortable: false, hide: true, },
        { field: "hasExternalLLMs", headerName: 'Has External LLMs', minWidth: 150, sortable: false, hide: true, },
        { field: "llmProviders", headerName: 'LLM Providers', minWidth: 150, sortable: false, hide: true, },
        { field: "llmTraining", headerName: 'LLM Training', minWidth: 150, sortable: false, hide: true, },
        { field: "llmdDataShared", headerName: 'LLM Data Shared', minWidth: 150, sortable: false, hide: true, },
        { field: "llmUnder18Treatment", headerName: 'LLM Under 18 Treatment', minWidth: 150, sortable: false, hide: true, },
        { field: "llmRestrict", headerName: 'LLM Restrict', minWidth: 150, sortable: false, hide: true, },
       
        


    ];

    return columns;
}
export function useValidationSchema() {

    //const UrlRe = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$|^$/gm

    const UrlRe = RegExp('^$|(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
    const validationSchema = Yup.object().shape({
        id: Yup.number(),

        vendorId: Yup.number()
            .required('Vendor is required')
            .min(1, 'Please select a vendor'),
        itOwnerId: Yup.number(),
        collectionModeId: Yup.number(),
        collectionModeOther: Yup.string()
            .nullable()
            .max(250, 'Other Collection Mode must not exceed 150 characters'),
        name: Yup.string()
            .required('Application Name is required')
            .max(150, 'Application must not exceed 150 characters'),
        url: Yup.string()
            .required('URL is required')
            .matches(UrlRe, 'URL is not valid')
            .min(6, 'URL must be at least 6 characters')
            .max(150, 'URL must not exceed 150 characters'),
        description: Yup.string()
            .required('Description is required')
            .max(1000, 'Description  must not exceed 1000 characters'),
        cloudHosted: Yup.boolean()
            .required('Cloud Hosted is required')
            .typeError('Cloud Hosted must be Yes or No'),
        cloudProviderId: Yup.string()
            .nullable(),
        cloudProvider: Yup.string()
            .max(150, 'Cloud Provider must not exceed 150 characters')
            .nullable(),
        startDate: Yup.string()
            .nullable()
            .test("startDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        endDate: Yup.string()
            .nullable()
            .test("endDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        other: Yup.string()
            .nullable(),
        applicableDepartmentsOther: Yup.string()
            .max(350, 'Field cannont exceed 350 characters')
            .nullable(),
        generalApplicationNotes: Yup.string()
            .max(2000, 'Field cannont exceed 2000 characters')
            .nullable(),
        other: Yup.string()
            .nullable()
            .max(1000, 'Other data collection must not exceed 1000 characters'),
        dataCollectionNotes: Yup.string()
            .nullable()
            .max(2000, 'Data collection notes must not exceed 2000 characters'),
        dataProtectionNotes: Yup.string()
            .nullable()
            .max(2000, 'Data protection notes must not exceed 2000 characters'),

        privacyUrl: Yup.string()
            .matches(UrlRe, 'URL is not valid')
            .max(150, 'URL must not exceed 150 characters')
            .nullable(),
        privacyNotification: Yup.string()
            .nullable()
            .max(1000, 'Privacy Notification must not exceed 1000 characters'),
        privacyTraining: Yup.string()
            .nullable()
            .max(1000, 'Privacy Training must not exceed 1000 characters'),
        subcontractors: Yup.string()
            .nullable()
            .max(1000, 'Subcontractors must not exceed 1000 characters'),
        subcontractorDataProtection: Yup.string()
            .nullable(),
        // .required('Subcontractor Data Protection is required')
        // .typeError('Subcontractor Data Protection must be Yes, No or N/A'),
        securityBreachInt: Yup.string()
            .nullable(),
        securityBreachDescription: Yup.string()
            .nullable()
            .max(1000, 'Security Breach Plan must not exceed 1000 characters'),
        auditFrequencyId: Yup.string()
            .nullable()
            .typeError('Please select Audit Frequency '),
        auditFrequencyOther: Yup.string()
            .nullable(true)
            .max(150, 'Other Audit Frequency must not exceed 150 characters')
            .when("auditFrequencyId", {
                is: (val) => val === -1,
                then: Yup.string().required("Other is selected, please provide other value"),
                otherwise: Yup.string().notRequired().nullable(),
            }),
        lastAuditDate: Yup.string()
            .nullable()
            .test("lastAuditDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        securityBreachPlan: Yup.string()
            .nullable()
            .max(2000, 'Security Breach Plan must not exceed 2000 characters'),
        privacyPracticeReview: Yup.string()
            .nullable()
            .max(1000, 'Privacy Practice Review must not exceed 1000 characters'),
        vendorSaleAssurance: Yup.string()
            .nullable()
            .max(1000, 'Vendor Sale Assurance must not exceed 1000 characters'),
        dataBackup: Yup.string()
            .nullable()
            .max(2500, 'Data Backup and storage must not exceed 2500 characters'),
        lossProtection: Yup.string()
            .nullable()
            .max(2500, 'Loss Protection must not exceed 2500 characters'),
        dataSinglePurpose: Yup.bool()
            // .required('Data Single Purpose is required')
            // .typeError('Data Single Purpose must be Yes or No'),
            .nullable(),
        dataRetentionPolicy: Yup.string()
            .nullable()
            .max(2500, 'Data Retention Policy must not exceed 2500 characters'),
        dataRetentionLength: Yup.string()
            .nullable()
            .max(1000, 'Data Retention Length must not exceed 1000 characters'),
        dataAfterDiscontinuing: Yup.string()
            .nullable()
            .max(2500, 'Data Discontuance must not exceed 2500 characters'),
        dataHandlingNotes: Yup.string()
            .nullable()
            .max(2000, 'Data handling notes must not exceed 2000 characters'),
        complianceNotes: Yup.string()
            .nullable()
            .max(2000, 'Compliance notes must not exceed 2000 characters'),
        approvalNotes: Yup.string()
            .nullable()
            .max(2000, 'Approval notes must not exceed 2000 characters'),



        gDPRCompliant: Yup.boolean()
            .nullable(),
        internetPipublished: Yup.boolean(),
        notApprovedReason: Yup.string()
            .nullable()
            .max(2500, 'Rationale for not approving must not exceed 2500 characters'),
        approverId: Yup.string()
            .nullable(),
        commonSenseRating: Yup.number()
            .nullable()
            .typeError('Common Sense must be a number')
            .max(100, 'Common Sense must not exceed 100 (percentage)'),
        commonSense: Yup.number()
            .nullable(true)
            .typeError('Common Sense must be a number')
            .max(2, 'Invalid value'),
        evalUrl: Yup.string()
            .nullable(true)
            .matches(UrlRe, 'URL is not valid')
            .max(350, 'URL must not exceed 350 characters'),
        gdprComplianceLevel: Yup.number()
            .nullable()
            .typeError('GDPR Compliance Level must be a number'),
        coppa: Yup.number()
            .nullable()
            .typeError('COPPA must be a number'),
        vendorConfirmed: Yup.boolean()
            .nullable()
            .typeError('Vendor Confirmation must be Yes or No'),
        dataLocationOther: Yup.string()
            .nullable(true)
            .notRequired()
            .max(250, 'Data Location must not exceed 250 characters'),
        hasExternalLLMs: Yup.boolean()
            .nullable()
            .typeError('External LLMs must be Yes or No'),
        llmProviders: Yup.string()
            .nullable()
            .max(1000, 'LLM Providers must not exceed 1000 characters'),
        llmTraining: Yup.boolean()
            .nullable()
            .typeError('LLM Training must be Yes or No'),
        llmDataShared: Yup.boolean()
            .nullable()
            .typeError('LLM Data Shared must be Yes or No'),
        llmUnder18Treatment: Yup.string()
            .nullable()
            .max(1000, 'LLM Under 18 Treatment must not exceed 1000 characters'),
        llmRestrict: Yup.string()
            .nullable()
            .max(1000, 'Restriction approach must not exceed 1000 characters'),


    });
    return validationSchema;
}


//var x = 1;
export async function saveApp(application, saveOrAddOrDelete, showError, showSuccess, setvalue, setIsLoading) {

    // debugger;
    if (setIsLoading !== null) {
        setIsLoading(true);
    }
    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
        method = 'POST';
        url = 'pia/';
    } else if (saveOrAddOrDelete === 'Save') {
        method = 'PUT';
        url = 'pia/' + application.id;
    }
    else if (saveOrAddOrDelete === 'own') {
        method = 'PUT';
        url = 'pia/own/' + application.id;
    }
    else if (saveOrAddOrDelete === 'Delete') {
        method = 'DELETE';
        url = 'pia/' + application.id;
    }
    try {
        //debugger;
        const requestOptions = {
            method: method,
            //headers: { 'Content-Type': 'application/json', 'Authorization': application.accessToken },
            headers: { 'Content-Type': 'application/json', 'Authorization' : localStorage.getItem("userToken") },
            body: JSON.stringify(application)
        };
        var result;
        
        if (saveOrAddOrDelete === 'Add') {
            result = await fetch(url, requestOptions).then(data => data.json()).then(
                (data) => {
                    if (setvalue !== null) {
                        setvalue("id", data);  //set value of ID so subsequent saves become updates
                    }

                    setTimeout(() => {
                        if (setIsLoading !== null) {
                            setIsLoading(false);
                        }
                       
                    }, 3000);

                    //result = {ok: true};
                    //setIsLoading(false);
                });
        }
        else {
            result = await fetch(url, requestOptions); 
            // result = await fetch(url, requestOptions).then(
            //     (result) => {
                    if (result && result.ok === false) {

                        showError();
                        if (setIsLoading !== null) {
                            setIsLoading(false);
                        }
            
                    } else {
                        switch (saveOrAddOrDelete) {
                            case 'Save':
                                showSuccess("Update Successful");
                                break;
                            case 'Add':
                                showSuccess("New record added successfully");
                                break;
                            case 'own':
                                showSuccess("This PIA has been moved into your Institution environment and should be customized accordingly");
                                break;
                            case 'Delete':
                                showSuccess("Record Inactivated");
                                break;
                            default:
                                showSuccess("Update Successful");
                        }
                        if (setIsLoading !== null) {
                            setIsLoading(false);
                        }
            
                    }
                }
            // );
                
        // }
        //debugger;
       

    } catch (e) {
        //debugger;
        showError();

    } finally {
        //for rerendering updated data
        //debugger;
        //setIsLoading(false);
        //rerender(false);// x++;
    }
}
export const UrlRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');

export function useMenuItemProps() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    return MenuProps;
}

export function useHandleMultiSelectChange(event, setgradesSelected, setstudentInfoSelected, setstaffInfoSelected, setparentInfoSelected, setalumniInfoSelected, setareaOfUseSelected, setDataLocationSelected, setgradesNASelected, setstudentInfoNASelected, setstaffInfoNASelected, setparentInfoNASelected, setalumniInfoNASelected, setotherDepartmentsShow, setCollectionModesSelected, setVolunteerInfoSelected, setVolunteerInfoNASelected, data) {
    
    const {
        target: { value },
    } = event;

    //TODO:  only put the array to handle in the switch statement - then common code after
    var allItemArray = [];
    var setItemsFunction = null;
    var setNAFunction = null;

    //debugger;
    switch (event.target.name) {
        case 'gradesSelected':

            allItemArray = data[0].gradeList;
            setItemsFunction = setgradesSelected;
            setNAFunction = setgradesNASelected;



            break;
        case 'studentInfoSelected':

            if (data === undefined) {
                setstudentInfoSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,

                );
                if (value.indexOf('N/A') > -1) {
                    setstudentInfoNASelected(true);
                } else {
                    setstudentInfoNASelected(false);
                }
                break;
            }
            allItemArray = data[0].studentInfoList;
            setItemsFunction = setstudentInfoSelected;
            setNAFunction = setstudentInfoNASelected;


            break;

        case 'staffInfoSelected':
            if (data === undefined) {
                if (value.indexOf('Select All') > -1) {
                    //loop through all items in array and add to selected
                    var allItems = [];
                    for (var i = 0; i < data[0].staffInfoList.length; i++) {
                        if (data[0].staffInfoList[i] !== 'N/A') {
                            allItems.push(data[0].staffInfoList[i]);
                        }
                    };
                    setstaffInfoSelected(allItems);
                }
                else {
                    setstaffInfoSelected(
                        // On autofill we get a stringified value.
                        typeof value === 'string' ? value.split(',') : value,
                    );
                }

                if (value.indexOf('N/A') > -1) {
                    setstaffInfoNASelected(true);
                } else {
                    setstaffInfoNASelected(false);
                }
                break;
            }
            allItemArray = data[0].staffInfoList;
            setItemsFunction = setstaffInfoSelected;
            setNAFunction = setstaffInfoNASelected;

            break;



        case 'parentInfoSelected':

            if (data === undefined) {
                setparentInfoSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                );
                if (value.indexOf('N/A') > -1) {
                    setparentInfoNASelected(true);
                } else {
                    setparentInfoNASelected(false);
                }
                break;

            }

            allItemArray = data[0].parentInfoList;
            setItemsFunction = setparentInfoSelected;
            setNAFunction = setparentInfoNASelected;


            break;

        case 'alumniInfoSelected':
            if (data === undefined) {
                setalumniInfoSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                );
                if (value.indexOf('N/A') > -1) {
                    setalumniInfoNASelected(true);
                } else {
                    setalumniInfoNASelected(false);
                }
                break;
            }
            allItemArray = data[0].alumniInfoList;
            setItemsFunction = setalumniInfoSelected;
            setNAFunction = setalumniInfoNASelected;

            // setalumniInfoSelected(
            //     // On autofill we get a stringified value.
            //     typeof value === 'string' ? value.split(',') : value,
            // );
            // if (value.indexOf('N/A') > -1) {
            //     setalumniInfoNASelected(true);
            // } else {
            //     setalumniInfoNASelected(false);
            // }
            break;

        case 'volunteerInfoSelected':
            if (data === undefined) {
                setVolunteerInfoSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                );
                if (value.indexOf('N/A') > -1) {
                    setVolunteerInfoNASelected(true);
                } else {
                    setVolunteerInfoNASelected(false);
                }
                break;
            }
            allItemArray = data[0].volunteerInfoList;
            setItemsFunction = setVolunteerInfoSelected;
            setNAFunction = setVolunteerInfoNASelected;

            // setVolunteerInfoSelected(
            //     // On autofill we get a stringified value.
            //     typeof value === 'string' ? value.split(',') : value,
            // );
            // if (value.indexOf('N/A') > -1) {
            //     setVolunteerInfoNASelected(true);
            // } else {
            //     setVolunteerInfoNASelected(false);
            // }
            break;

        case 'areaOfUseSelected':
            allItemArray = data[0].areaOfUseList;
            setItemsFunction = setareaOfUseSelected;

            // setareaOfUseSelected(
            //     // On autofill we get a stringified value.
            //     typeof value === 'string' ? value.split(',') : value,
            // );
            if (value.indexOf('Other') > -1) {
                setotherDepartmentsShow(true);
            } else {
                setotherDepartmentsShow(false);
            }
            break;

        case 'dataLocationSelected':

            if (data === undefined) {
                setDataLocationSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                );
                break;
            }
            allItemArray = data[0].dataLocationList;
            setItemsFunction = setDataLocationSelected;

            // setDataLocationSelected(
            //     // On autofill we get a stringified value.
            //     typeof value === 'string' ? value.split(',') : value,
            // );
            break;

        case 'collectionModesSelected':

            if (data === undefined) {
                setCollectionModesSelected(
                    // On autofill we get a stringified value.
                    typeof value === 'string' ? value.split(',') : value,
                );
                if (value.indexOf('N/A') > -1) {
                    setNAFunction(true);
                } else {
                    if(setNAFunction !== null){
                        setNAFunction(false);
                    }
                    
                }
                setItemsFunction = setCollectionModesSelected;
                break;
            }


            allItemArray = data[0].collectionModesList;
            setItemsFunction = setCollectionModesSelected;

            // setCollectionModesSelected(
            //     // On autofill we get a stringified value.
            //     typeof value === 'string' ? value.split(',') : value,
            // );

            break;


        default:
            break;
    }

    if (value.indexOf('Select All') > -1) {
        //loop through all items in array and add to selected
        var allItems = [];
        for (var i = 0; i < allItemArray.length; i++) {
            if (allItemArray[i] !== 'N/A') {
                allItems.push(allItemArray[i]);
            }
        };
        setItemsFunction(allItems);
    }
    else {
        setItemsFunction(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }
    if (setNAFunction !== null) {
        if (value.indexOf('N/A') > -1) {
            setNAFunction(true);
        } else {
            setNAFunction(false);
        }
    }

};
export function handleCloudHostedChange(event, setCloudHosted) {

    setCloudHosted(event.target.value === '1');

};

export function handleBooleanRadioButtonChange(event, setFunction) {
    setFunction(event.target.value === '1');

};
export function handleSecurityBreachChange(event, setFunction) {

    setFunction(event.target.value);
};

export function handleSubcontractorRadioButtonChange(event, setFunction){
    setFunction(event.target.value);
};




